import { Injectable, signal } from '@angular/core';

export type SnackbarTipo = 'sucesso' | 'erro' | 'info';

export interface SnackbarMsg {
  id: number;
  texto: string;
  tipo: SnackbarTipo;
  duracao: number;
}

let nextId = 1;

/**
 * Snackbar global — qualquer componente injeta `SnackbarService` e chama
 * `.sucesso()`, `.erro()`, `.info()`. O componente `<app-snackbar-host>`
 * (root layout) escuta e renderiza no canto.
 *
 * Multiple toasts stack verticalmente. Auto-dismiss configurável.
 */
@Injectable({ providedIn: 'root' })
export class SnackbarService {
  readonly mensagens = signal<SnackbarMsg[]>([]);

  sucesso(texto: string, duracao = 4_000): void {
    this.show({ texto, tipo: 'sucesso', duracao });
  }

  erro(texto: string, duracao = 6_000): void {
    this.show({ texto, tipo: 'erro', duracao });
  }

  info(texto: string, duracao = 4_000): void {
    this.show({ texto, tipo: 'info', duracao });
  }

  dispensar(id: number): void {
    this.mensagens.update((cur) => cur.filter((m) => m.id !== id));
  }

  private show(opts: { texto: string; tipo: SnackbarTipo; duracao: number }): void {
    const id = nextId++;
    const msg: SnackbarMsg = { id, ...opts };
    this.mensagens.update((cur) => [...cur, msg]);
    if (opts.duracao > 0) {
      setTimeout(() => this.dispensar(id), opts.duracao);
    }
  }
}
